module.exports = __webpack_public_path__ + "img/status3.e2a6e86d.png";